import { render, staticRenderFns } from "./AdministrativeUnitList.vue?vue&type=template&id=7631bc66&"
import script from "./AdministrativeUnitList.vue?vue&type=script&lang=js&"
export * from "./AdministrativeUnitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports